/**
 * Closed registry of resource types that support direct access grants.
 * Growing this union means adding a resource registry entry, an
 * `AccessTarget` mapping, and grant tables — never a new handler hierarchy.
 */
export var DirectAccessResourceType;
(function (DirectAccessResourceType) {
    DirectAccessResourceType["DOCUMENT"] = "document";
    DirectAccessResourceType["DASHBOARD"] = "dashboard";
    DirectAccessResourceType["CHART"] = "chart";
    DirectAccessResourceType["SQL_CHART"] = "sqlChart";
    DirectAccessResourceType["APP"] = "app";
})(DirectAccessResourceType || (DirectAccessResourceType = {}));
export var DirectAccessPrincipalType;
(function (DirectAccessPrincipalType) {
    DirectAccessPrincipalType["USER"] = "user";
    DirectAccessPrincipalType["GROUP"] = "group";
})(DirectAccessPrincipalType || (DirectAccessPrincipalType = {}));
//# sourceMappingURL=directAccess.js.map